/* Aegean Vibe — theme.js (schlank, ohne Framework) */
(function () {
  "use strict";

  /* --- Mobile-Menü Drawer --- */
  var burger = document.querySelector(".burger");
  var drawer = document.getElementById("MobileMenu");
  function closeDrawer() {
    if (!drawer) return;
    drawer.setAttribute("hidden", "");
    document.body.style.overflow = "";
  }
  if (burger && drawer) {
    burger.addEventListener("click", function () {
      if (drawer.hasAttribute("hidden")) {
        drawer.removeAttribute("hidden");
        document.body.style.overflow = "hidden";
      } else {
        closeDrawer();
      }
    });
    drawer.addEventListener("click", function (e) {
      if (e.target.closest("[data-close]")) closeDrawer();
    });
    document.addEventListener("keyup", function (e) {
      if (e.key === "Escape") closeDrawer();
    });
  }

  /* --- Mengen-Stepper (PDP) --- */
  document.addEventListener("click", function (e) {
    var b = e.target.closest("[data-qty]");
    if (!b) return;
    var step = b.closest(".step");
    var input = step && step.querySelector('input[type="number"]');
    if (!input) return;
    var v = parseInt(input.value, 10) || 1;
    v += b.getAttribute("data-qty") === "up" ? 1 : -1;
    if (v < 1) v = 1;
    input.value = v;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });

  /* --- Warenkorb-Zähler nach AJAX-Add aktualisieren (falls genutzt) --- */
  window.refreshCartCount = function () {
    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll("[data-cart-count]").forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      })
      .catch(function () {});
  };
})();
